<template>
  <div class="step step--school-type">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <div xl="8" md="10" sm="12">
          <div class="mb-4 header">
            <h2>How about the type of school?</h2>
            <p>This will help estimate your tuition cost. The type of school can change those numbers a bit.</p>
          </div>
        </div>
      </div>
      <div class="step__options">
        <div v-for="type in types" v-bind:key="type.key" :class="'step__option styled-radio styled-radio-horizontal styled-radio-' + type.icon">
          <template v-if="type.icon === 'school'">
            <icon-school />
          </template>
          <template v-else-if="type.icon === 'university'">
            <icon-university />
          </template>
          <template v-else>
            <icon-undecided />
          </template>
          <input :id=type.key type="radio" v-model="user.type" :value=type.key> <label :for=type.key v-html="type.label" class="mr-0"></label>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBack from '../buttons/Back.vue'
import IconSchool from '../animatedicons/IconSchool.vue'
import IconUniversity from '../animatedicons/IconUniversity.vue'
import IconUndecided from '../animatedicons/IconUndecided.vue'
import Disclaimer from '../Disclaimer.vue'

export default {
  name: 'SchoolTypeStep',
  props: {
    user: Object
  },
  data: function () {
    return {
      types: [
        {
          key: 'public',
          label: '<h4>Public university</h4><p>Public universities are funded by state governments and tend to offer lower tuition rates for residents.</p>',
          icon: 'school'
        },
        {
          key: 'private',
          label: '<h4>Private university</h4><p>Private universities are privately funded and tend to be more costly.</p>',
          icon: 'university'
        },
        {
          key: 'unsure',
          label: '<h4>I\'m not sure</h4><p>Don’t worry. Lots of students are still figuring things out, too.</p>',
          icon: 'undecided'
        },
      ]
    }
  },
  methods: {
    back: function () {
      this.user.schoolKnown = null;
      this.$emit('back');
    }
  },
  mounted: function () {
    this.user.type = null;
  },
  watch: {
    'user.type': function () {
      if (this.user.type) {
        this.$emit('completed');
      }
    },
  },
  components: {
    ButtonBack,
    IconSchool,
    IconUniversity,
    IconUndecided,
    Disclaimer,
  }
}
</script>

<style scoped>
</style>
